import { useEffect, useRef, useState } from 'react';

// <= 767 - defined as mobile (iphone etc.)
export const MOBILE_BREAKPOINT = 767;

// tablet range [768, 1023]
export const TABLET_BREAKPOINT_START = 768;
export const TABLET_BREAKPOINT_END = 1023;

// DESKTOP >= 1024
export const DESKTOP_BREAKPOINT = 1024;

/**
 * checks if Web Animation API is supported
 */
export const isWebAnimationSupported = () => {
    return 'animate' in document.createElement('div');
};
/**
 * if resize observer is supported
 * https://web.dev/resize-observer/
 */
export const isResizeObserverSupported = () => {
    return 'ResizeObserver' in window;
};

/**
 * get viewport width
 */
export const getViewportWidth = () => {
    return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
};

/**
 * get window width / height
 */
export const getWindowDimensions = () => {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    }
};

/**
 * window resize observer hook
 * returns width and height on window resize
 * usage:
 * -------
 * const [width, height] = useWindowResizeObserver();
 * console.log(width, height);
 */
export const useWindowResizeObserver = () => {

    const [width, setWidth] = useState(document.body.clientWidth);
    const [height, setHeight] = useState(document.body.clientWidth);

    const observer = useRef(isResizeObserverSupported() ?
        new ResizeObserver(entries => {

            if(!entries || entries.length <= 0) return;

            const { width, height } = entries[0].contentRect;
            setWidth(width);
            setHeight(height);
        }) : null
    );

    useEffect(() => {

        observer?.current?.observe(document.body);

        return () => { // eslint-disable-next-line
            observer?.current?.unobserve(document.body);
        }
    }, []);

    return [
        width,
        height,
    ];
};

export const getWidth = async ($el: HTMLElement) : Promise<number> => {
    return new Promise((resolve, reject) => {
        const width = $el.style.getPropertyValue('width');
        $el.style.removeProperty('width');
        window.setTimeout(() => {
            const offsetWidth = $el.offsetWidth;
            $el.style.setProperty('width', width);
            window.setTimeout(() => {
                resolve(offsetWidth);
            }, 0);
        }, 0);
    });
};